// API 配置
// 开发环境使用相对路径（通过 Vite 代理）
// 生产环境使用环境变量中的 API 地址

const getApiBaseUrl = () => {
  // 如果有环境变量，使用环境变量
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL
  }
  // 否则使用相对路径（需要后端配置 CORS 或通过代理访问）
  return ''
}

export const API_BASE_URL = getApiBaseUrl()

// 图片 URL 转换：统一转为同域代理路径，避免国内被墙
export const getImageUrl = (url: string): string => {
  if (!url) return url
  // 已经是代理 URL，保持不变
  if (url.startsWith('https://dlsy.space/api/images/')) return url
  // 相对代理路径 → 补全域名
  if (url.startsWith('/api/images/')) return `https://dlsy.space${url}`
  // 老的 dlsy.space 直连 URL → 转为代理路径
  if (url.startsWith('https://dlsy.space/')) {
    const key = url.replace('https://dlsy.space/', '')
    return `https://dlsy.space/api/images/${key}`
  }
  // R2.dev 直连 URL → 转为代理路径
  const r2Match = url.match(/^https:\/\/[a-z0-9-]+\.r2\.dev\/(.+)$/)
  if (r2Match) {
    return `https://dlsy.space/api/images/${r2Match[1]}`
  }
  return url
}

export const API_ENDPOINTS = {
  cases: '/api/cases',
  categories: '/api/categories',
  paymentReports: '/api/payment-reports',
  leads: '/api/leads'
}
